import React, { useState } from "react";
import { useParams } from "react-router";
import { Heading, Loader, Popup } from "uikit/components";
import { BackLink } from "components";
import styles from "./MunicipalityTrainingPlansPage.module.styl";
import MunicipalityTrainingPlansView from "components/municipalitySummary/MunicipalityTrainingPlansView/MunicipalityTrainingPlansView";
import { useMunicipalityTrainingPlans } from "hooks/trainingPlans/useMunicipalityTrainingPlans";
import Pagination from "uikit/components/Pagination/Pagination";
import math from "lodash";
import { Flags } from "utils";
import { useContextPerson } from "hooks/persons";
import { Helmet } from "react-helmet-async";

export default function MunicipalityTrainingPlansPage() {
    const pageSize = 20;

    const [payload, setPayload] = useState({ pageNumber: 1 });

    const { municipalityId } = useParams();
    const { flags, isLoading: isContextLoading } = useContextPerson();
    const { isLoading, data } = useMunicipalityTrainingPlans(municipalityId, payload, {
        keepPreviousData: true,
    });

    const handlePageChange = (newPageNumber) => {
        setPayload((payload) => ({ ...payload, pageNumber: newPageNumber }));
    };

    if (isLoading || isContextLoading) {
        return (
            <Popup blockClickOnOverlay appearance="adaptive">
                <Loader position={"margin-auto"} text={"Подождите. Данные загружаются."} testName="loader-text" />
            </Popup>
        );
    }

    if (data) {
        return (
            <>
                <Helmet>
                    <meta
                        name="apple-mobile-web-app-title"
                        content={`Ведение планов тренировок: {data.municipalityName}`}
                    />
                    <meta
                        name="application-name"
                        content={`Ведение планов тренировок: {data.municipalityName}`}
                    />
                </Helmet>
                {!flags?.[Flags.HideDashboardBackButton] && (
                    <BackLink
                        to={`/municipality-summary/${municipalityId}`}
                        text={"Назад"}
                        name={"back_link"}
                        data-test-name="back-municipality-dashboard"
                    />
                )}
                <Heading size={"h1"} className={styles.heading} name="municipality-training-plans-header">
                    Ведение планов тренировок: {data.municipalityName}
                </Heading>
                <MunicipalityTrainingPlansView
                    municipalityId={Number(municipalityId)}
                    schoolTrainingPlans={data.schoolTrainingPlans}
                />
                {data.count > pageSize && (
                    <Pagination
                        pageCount={math.ceil(data.count / pageSize)}
                        forcePage={payload.pageNumber}
                        onPageChange={handlePageChange}
                        className={styles.pagination}
                    />
                )}
            </>
        );
    }
}
